import React ,{useEffect, useState} from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { FormTextArea } from "_components/FormElements/FormInput";
import { useTheme } from '@material-ui/core/styles';
import { useForm} from "react-hook-form";
import MenuItem from '@mui/material/MenuItem';
import {
  Card, CardBody, Col, Row, Badge
} from "reactstrap";
import { FormAutocomplete } from "_components/FormElements/FormInput";
import {
Button, Modal,
} from "reactstrap";
import Select from '@mui/material/Select';
import {  FormRadio } from "_components/FormElements/FormInput";
import { ProfileUploader } from '../ProfileUpload';
import { commonService } from '_services/common.service';
import {Spinner} from 'views/Hoc/Spinner';
import axios from "axios";
import { FormCheckBox} from "_components/FormElements/FormInput";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import ConfirmDialog from 'views/Hoc/Dialog/GlobalDialog';
import FadeLoader  from "react-spinners/FadeLoader";
import { history } from '../../../_helpers';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker, KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
  

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

  // const onChangedate = (date) => {
  //   console.log('datedatedate :', date)
  //   // if (date) {
  //   //   handleChangeSelect('lastUpdated', [date[0].toISOString().slice(0, 10), date[1].toISOString().slice(0, 10)])
  //   //   setLastUpdatedalt([date[0].toISOString().slice(0, 10), date[1].toISOString().slice(0, 10)])
  //   // } else {
  //   //   handleChangeSelect('lastUpdated', null);
  //   //   setLastUpdatedalt(null)
  //   // }
  // }

export const DateRangeFilter = (props) => {

  const { open, handleClose, handleSave, value , handleChangeSelect} = props;

  const theme = useTheme();
  const {  control } = useForm({
    mode: 'onBlur',
    //resolver: yupResolver(GeneralFormSchema),
  });
  const [lastUpdatedalt, setLastUpdatedalt] = useState(null);
  const [montlyChange, setMontlyChange] = useState(null);  
  const [month, setMonth] = useState([]);
  const [monthwise, setMonthwise] = useState([]);
  const [monthwisefrom, setMonthwisefrom] = useState();
  const [monthwiseto, setMonthwiseto] = useState();
  const [dateFilter, setDateFilter] = useState('1');
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [lastUpdatedDiv, setLastUpdatedDiv] = useState(true);
  const [monthDiv, setMonthDiv] = useState(false);
  const [monthYearDiv, setMonthYearDiv] = useState(false);
  const [selectYearfrom, setSelectYearfrom] = useState(null);
  const [selectYearto, setSelectYearto] = useState(null);
  const [disableConfirm, setDisableConfirm] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);
  
  const [selOpt, setSelOpt] = useState({ id: "1", name: "Not Updated" });
  const [monthBetween, setMonthBetween] = useState(null);  
  const [updatedAtLimit, setUpdatedAtLimit] = useState(null);
  const [confirmData, setConfirmData] = useState({filterType:null, dateRange:null, filterMode: null}); 
  // const handleClose = () => {
  //   handleClose()
  // }


  const handleChange = (input, e) => {

    setDateFilter(null)
    setDisableConfirm(true)
    if(e == 1) {
      setLastUpdatedDiv(true)
      setMonthDiv(false)
      setMonthYearDiv(false)
      setConfirmData({...confirmData ,filterType : 1})
    } else if(e == 2) {
      setMonthDiv(true)
      setLastUpdatedDiv(false)
      setMonthYearDiv(false)
       setConfirmData({...confirmData , filterType:2})
    } else if(e == 3) {
      setMonthYearDiv(true)
      setMonthDiv(false)
      setLastUpdatedDiv(false)
       setConfirmData({...confirmData , filterType:3})
    }
    setDateFilter(e)
  } 

  const handleChangeMonth = (inp , e) => {
   
    if(e?.id) {  
      setErrorMsg(null)
      if(inp == 'selectYearto') {
          setSelectYearto(e)
      } else if (inp == 'selectYearfrom'){
          setSelectYearfrom(e)          
      } else if (inp == 'monthwiseto'){
          setMonthwiseto(e)
      } else if (inp == 'monthwisefrom'){
          setMonthwisefrom(e)
      }

      if((monthwiseto !=  null || inp == 'monthwiseto' ) && (monthwisefrom != null  || inp == 'monthwisefrom') && (selectYearto != null  || inp == 'selectYearto' ) && (selectYearfrom != null  || inp == 'selecselectYearfromtYearto')) {
       // console.log('test ')
        setDisableConfirm(false)
      }
      if((inp == 'selectYearto' && selectYearfrom !=  null) && selectYearfrom?.id >  +e.id  ) {
       // console.log('error in from date: ');
        setErrorMsg('Invalid To Year, To date must be greater than to from date')
        setDisableConfirm(true)
      }
      if((inp == 'selectYearfrom' && selectYearto !=  null) && selectYearto?.id >  e?.id  ) {
       // console.log('error in to date: selectYearfrom ',e)
        setErrorMsg('Invalid From Year, To date must be greater than to from date')
        setDisableConfirm(true)
      }

      if((inp == 'monthwiseto' && monthwisefrom !=  null) && (selectYearto == selectYearfrom) &&  (monthwisefrom != null && monthwisefrom?.id >  +e.id)  ) {
        //console.log('error in to date: ')
              setErrorMsg('Invalid To Month,To date must be greater than to from date')
              setDisableConfirm(true)
      }

      if((inp == 'monthwisefrom' && monthwiseto !=  null) && (selectYearto == selectYearfrom) &&  (monthwiseto != null && monthwiseto?.id >  +e.id)  ) {
        //console.log('error in to date: ')
              setErrorMsg('Invalid To Month,To date must be greater than to from date')
              setDisableConfirm(true)
      }

      if((inp == 'selectYearto' && (monthwiseto !=  null && monthwisefrom != null)) && (selectYearto == selectYearfrom) && monthwisefrom?.id >  +monthwiseto.id  ) {
       // console.log('error in from date: ');
        setErrorMsg('Invalid To Month, To date must be greater than to from date')
        setDisableConfirm(true)
      }
    }
    
  }

  const handleMonthDiv = (inp, e) => {
  //  console.log('month in between : ', e)
      setMonthBetween(e)
      setDisableConfirm(false);      
  }

  const onChangedate = (date) => {
      setUpdatedAtLimit(null);
      setDisableConfirm(true); 
    if(date > new Date()){
      //console.log(' greater : ', date)
      setUpdatedAtLimit(date)
    } else {
      //setUpdatedAtLimit([date.toISOString().slice(0, 10), null])
      setUpdatedAtLimit(date)
      // console.log(' correct : ', date)
      setDisableConfirm(false);   
    } 
  }
  
 const handleConfirm = (data) => {
  
    let updateByFilter;
    let filterMode = 'include'
    if(dateFilter  == 1) {
      
      //  dateFilter = {fromdate : updatedAtLimit[0] , todate : updatedAtLimit[1] } 
      updateByFilter = {fromdate : updatedAtLimit.toISOString().slice(0, 10)  } 
      filterMode = (selOpt.id == '1')?'include':'exclude';
    } else if(dateFilter  == 2) {
      let cDate = new Date();      
      updateByFilter = [];
     // console.log('cDate.getMonth() ', cDate.getMonth())

      let month = ['01','02','03','04','05','06','07','08','09','10','11','12']
      let cdate = month[cDate.getMonth()];
 
      let sDate;
     
      if(+monthBetween.id == 1 || +monthBetween.id == 4){                    
          sDate = new Date(cDate.setMonth((cDate.getMonth()) - 1));           
      } else if(+monthBetween.id == 2 || +monthBetween.id == 5){
          sDate = new Date(cDate.setMonth((cDate.getMonth()) - 3));
      } else if(+monthBetween.id == 3 || +monthBetween.id == 6){
          sDate = new Date(cDate.setMonth((cDate.getMonth()) - 6));
      } 

      updateByFilter = {fromdate : sDate.getFullYear()+'-'+ month[sDate.getMonth()] +'-'+sDate.getDate() , todate : cDate.getFullYear()+'-'+ cdate +'-'+cDate.getDate() }

      if(+monthBetween.id == 4 || +monthBetween.id == 5 || +monthBetween.id == 6){
        filterMode = 'exclude'
      }
    } else if(dateFilter  == 3) {

      updateByFilter = {fromdate : selectYearfrom?.id+'-'+monthwisefrom?.id+'-01' , todate : selectYearto?.id+'-'+monthwiseto?.id+'-01'    }
       
    }
    
   // setConfirmData({...confirmData ,dateRange : updateByFilter, filterMode : filterMode})
    //console.log('finaldata : ', [{filterType: confirmData.filterType , dateRange : updateByFilter, filterMode : filterMode}])
    handleSave([{filterType: confirmData.filterType , dateRange : updateByFilter, filterMode : filterMode}])
    
 }
 
 const handleOPtion = (inp, e) => {
  //console.log(inp , 'set option :', e)
  setSelOpt(e)
 }
  
 
  return (
    <div>
      <Modal className="modal-dialog-centered" isOpen={open}>
        <div className="modal-header">
          <strong>{value.title}</strong>
          <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={handleClose}>
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <div>
            <FormRadio
              name="multiMeet"
              className="text-sm d-inline mb-0"
              label="Please select the date filter option"
              options={dateRangeOption}
              control={control}
              // register={register}
              // row
              onChange={handleChange}
              value={dateFilter}
              defaultValue={dateFilter}
              error={dateFilter}
            />
          </div>
          
          <div>

            {lastUpdatedDiv && <div>
            {/* <DatePicker
              onChange={onChangedate}
              label="Stay duration" visibleMonths={2}
              id="updatedAtLimit"
              name="updatedAtLimit"
              value={updatedAtLimit}
            /> */}
            please select the date to filter the list of companies that are not updated from the given date
             <MuiPickersUtilsProvider utils={DateFnsUtils} >
            <KeyboardDatePicker
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              placeholder="MM/dd/yyyy"
              margin="normal"
              id="updatedAtLimit"
              name="updatedAtLimit"
              defaultValue={updatedAtLimit}
              value={updatedAtLimit}
              // ref={register}
              style={{border:"1px solid #ccc"}}
              control={control}              
              onChange={onChangedate}
            // KeyboardButtonProps={{
            //   'aria-label': 'change date',
            // }}
            />
          </MuiPickersUtilsProvider>
          
          <FormAutocomplete
              id="selOpt"
              name="selOpt"
              label="selOpt"
              options={selectOption}
              placeholder="Select Monthly Option"
              //multiple
              disableCloseOnSelect
              //limitTags={2}
              control={control}
              input='selOpt'
              value={selOpt}
              handleChangeSelect={handleOPtion}
            />  
            </div> }

            {monthDiv && <div style={{padding:"25px;"}}>
            <FormAutocomplete
              id="month"
              name="month"
              label="month"
              options={montlyOption}
              placeholder="Select Monthly Option"
              //multiple
              disableCloseOnSelect
              //limitTags={2}
              control={control}
              input='month'
              value={monthBetween}
              handleChangeSelect={handleMonthDiv}
            />    
            </div> }

            {monthYearDiv && <div style={{padding:"25px;"}}>
            <p>From Month & date </p>  
            <div style={{display:"inline-flex"}}>  
            <FormAutocomplete
              id="monthwisefrom"
              name="monthwisefrom"
              label="Month From"
              options={monthWiseOption}
              placeholder="Select Month From"
              //multiple
              disableCloseOnSelect
              style = {{width:"150px", padding:"5px"}}
              //limitTags={2}
              control={control}
              input='monthwisefrom'
              value={monthwisefrom}
              handleChangeSelect={handleChangeMonth}
            />   
           <FormAutocomplete
              id="selectYearfrom"
              name="selectYearfrom"
              label="Year From"
              style = {{width:"150px", padding:"5px"}}
              options={yearOption}
              placeholder="Select Year From"
              // multiple
              // disableCloseOnSelect
              //limitTags={2}
              control={control}
              input='selectYearfrom'
              value={selectYearfrom}
              handleChangeSelect={handleChangeMonth}
            />  
            </div>    
            <p>To Month & date </p>  
            <div style={{display:"inline-flex"}}>
            <FormAutocomplete
              id="monthwiseto"
              name="monthwiseto"
              label="Month To"
              options={monthWiseOption}
              placeholder="Select Month To"
              //multiple
              disableCloseOnSelect
              style = {{width:"150px", padding:"5px"}}
              //limitTags={2}
              control={control}
              input='monthwiseto'
              value={monthwiseto}
              handleChangeSelect={handleChangeMonth}
            />   
           <FormAutocomplete
              id="selectYearto"
              name="selectYearto"
              label="Year To"
              options={yearOption}
              placeholder="Select Year To"
              // multiple
              disableCloseOnSelect
              //limitTags={2}
              control={control}
              style = {{width:"150px", padding:"5px"}}
              input='selectYearto'
              value={selectYearto}
              handleChangeSelect={handleChangeMonth}
            />    
            </div>
            
            </div>}
          </div>
        </div>
        <div style={{color:"red", fontSize: "18px", paddingLeft:"30px"}}>
          {errorMsg}
        </div>
        <div className="modal-footer">
          {!disableConfirm && <Button color="primary" type="button" onClick={() => handleConfirm(value)}>Confirm</Button>}
          <Button color="secondary" data-dismiss="modal" type="button" onClick={handleClose}>Cancel</Button>
        </div>
      </Modal>
    </div>
  );
}
export default DateRangeFilter;
const dateRangeOption = [
  { value: "1", label: "Date Filter" },
  { value: "2", label: "Monly Range" },
  // { value: "3", label: "Month Filter" },
];

const selectOption = [
  { id: "1", name: "Updated" },
  { id: "2", name: "Not Updated" }
];

const montlyOption = [
  { id: "1", name: "Updated Within 1 Month" },
  { id: "2", name: "Updated Within 3 Month" },
  { id: "3", name: "Updated Within 6 Month" },
  { id: "4", name: "Not Updated more than 1 Month" },
  { id: "5", name: "Not Updated more than 3 Month" },
  { id: "6", name: "Not Updated more than 6 Month" },
];

//console.log('dateRangeOption : ', montlyOption)
const monthWiseOption = [
  { id: "01", name: "Jan" },
  { id: "02", name: "Feb" },
  { id: "03", name: "Mar" },
  { id: "04", name: "Apr" },
  { id: "05", name: "May" },
  { id: "06", name: "June" },
  { id: "07", name: "July" },
  { id: "08", name: "Aug" },
  { id: "09", name: "Sep" },
  { id: "10", name: "Oct" },
  { id: "11", name: "Nov" },
  { id: "12", name: "Dec" },
];


const yearOption = [];
  let s = 0
  for(let i = new Date().getFullYear(); i >= 2018; i--){
    s = s +1
    yearOption.push({id:i , name:i.toString()})
  }
 // console.log('yearOption : ', yearOption)